import { render } from "./groupInvDialog.vue?vue&type=template&id=2971067c&scoped=true"
import script from "./groupInvDialog.vue?vue&type=script&lang=js"
export * from "./groupInvDialog.vue?vue&type=script&lang=js"

import "./groupInvDialog.vue?vue&type=style&index=0&id=2971067c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2971067c"]])

export default __exports__